import { PDI_CAR_TYPE } from "../../../constants/pre-delivery-inspection-constants";
import { vasIndiaWebsiteUrl } from "../../../constants/url-constants";

export const PDI_INSPECT_KEYS = {
    [PDI_CAR_TYPE.USED_CAR]: "oldCarPdiProduct",
    [PDI_CAR_TYPE.NEW_CAR]: "newCarPdiProduct"
};

export const NEW_PDI_ROUTES = {
    [PDI_CAR_TYPE.USED_CAR]: `${vasIndiaWebsiteUrl()}/used-car-inspection-services`,
    [PDI_CAR_TYPE.NEW_CAR]: `${vasIndiaWebsiteUrl()}/new-car-pre-delivery-inspection-pdi`
};
